module.exports = {
  ADD_OKR_NEW: 'ADD_OKR_NEW',
  EDIT_OKR: 'EDIT_OKR',
  ADD_KR_NEW: 'ADD_KR_NEW',
  ADD_UPDATE_NESTED_KR: "ADD_UPDATE_NESTED_KR",
  DELETE_KR: 'DELETE_KR',
  EDIT_INLINE_KR: 'EDIT_INLINE_KR',
  UPDATE_GOAL_NAME: 'UPDATE_GOAL_NAME',
  UPDATE_EXT_APP: 'UPDATE_EXT_APP',
  REORDER_METRICS: 'REORDER_METRICS',
  UPDATE_KR_WEIGHT: 'UPDATE_KR_WEIGHT',
  // UPDATE_WS: 'UPDATE_WS'
  UPDATE_METRIC_NAME: 'UPDATE_METRIC_NAME',
  UPDATE_GOAL_ISKRMULTIPER: 'UPDATE_GOAL_ISKRMULTIPER',
  UPDATE_PERMISSIONS_IN_METRIC: 'UPDATE_PERMISSIONS_IN_METRIC',
  UPDATE_CLUSTER_DATA: 'UPDATE_CLUSTER_DATA',
  UPDATE_CLUSTER_DATA_FOR_ITEM: 'UPDATE_CLUSTER_DATA_FOR_ITEM',
};
